enum ModalStateType {
    Create,
    Edit,
    Overview,
}

export default ModalStateType;
